<template>
  <div v-if="selectedBirth">
    <show :birth="selectedBirth"></show>
  </div>
</template>

<script>
  import {mapGetters, mapActions, mapState} from 'vuex'
    import Show from '@/components/Births/Show'
    export default {
      components:{
        Show
      },
      computed:{
        ...mapState('births', ['selectedBirth'])
      }
  }
</script>
